import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

export default function NewHome() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Rediriger les utilisateurs connectés vers le dashboard approprié
    if (user) {
      if (user.role === 'admin' || user.role === 'super_admin') {
        navigate('/admin/dashboard');
      } else {
        navigate('/dashboard');
      }
    }
  }, [user, navigate]);

  return (
    <div className="">

      {/* Hero Section */}
      <div className="relative overflow-hidden pt-20">
        <div className="max-w-7xl mx-auto">
          <div className="relative z-10">
            <main className="mx-auto max-w-7xl px-4 sm:px-6">
              <div className="text-center">
                <p className="text-xl sm:text-2xl md:text-3xl block text-slate-700 uppercase pb-2">Bienvenue sur </p>
                <h1 className="text-4xl sm:text-5xl md:text-6xl block text-honey-500 font-extrabold">Abeille Réunion</h1>
                <p className="mt-3 max-w-md mx-auto text-base text-slate-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                  La plateforme dédiée aux apiculteurs des groupements. Rejoignez notre communauté, 
                  adhérez à un groupement et accédez à votre espace et aux services proposés.
                </p>
              </div>
            </main>
          </div>
        </div>
      </div>

      {/* Section Groupements */}
      <div id="groupements" className="pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col align-center">

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            {/* Carte SAR */}
            <div className="relative group text-center">
              <div className="relative bg-white rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden border border-slate-100 h-full flex flex-col">
                <div className="p-12 flex flex-col flex-grow">
                  <img src="/logos/logo_sar.png" alt="" className="mx-auto pb-8 h-46 object-contain" />
                  <p className="text-lg font-medium text-black mb-3 flex-grow min-h-[3.5rem]">
                    Syndicat Apicole de la Réunion
                  </p>
                  <div className="flex flex-col items-center mt-auto">
                    <Link
                      to="/groupement/sar"
                      className="text-slate-600 hover:text-black font-medium flex items-center group mb-4"
                    >
                      En savoir plus
                      <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </Link>
                    <Link
                      to="/adhesion/sar"
                      className="w-full text-lg font-semibold px-6 py-2 bg-[#F5B844] text-white rounded-lg hover:bg-[#F5B844] transition-colors"
                    >
                      Adhérer
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Carte ADAR */}
            <div className="relative group text-center">
              <div className="relative bg-white rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden border border-slate-100 h-full flex flex-col">
                <div className="p-12 flex flex-col flex-grow">
                  <img src="/logos/logo_adar.png" alt="" className="mx-auto pb-8 h-46 object-contain" />
                  <p className="text-lg font-medium text-black mb-3 flex-grow min-h-[3.5rem]">
                    Association pour le Développement de l'Apiculture à l'île de La Réunion
                  </p>
                  <div className="flex flex-col items-center mt-auto">
                    <Link
                      to="/groupement/adar"
                      className="text-slate-600 hover:text-black font-medium flex items-center group mb-4"
                    >
                      En savoir plus
                      <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </Link>
                    <Link
                      to="/adhesion/adar"
                      className="w-full text-lg font-semibold px-6 py-2 bg-[#0B4395] text-white rounded-lg hover:bg-[#0B4395] transition-colors"
                    >
                      Adhérer
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* Carte AMAIR */}
            <div className="relative group text-center">
              <div className="relative bg-white rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden border border-slate-100 h-full flex flex-col">
                <div className="p-12 flex flex-col flex-grow">
                  <img src="/logos/logo_amair.png" alt="" className="mx-auto pb-8 h-46 object-contain" />
                  <p className="text-lg font-medium text-black mb-3 flex-grow min-h-[3.5rem]">
                    Association de la Maison de l'Apiculture de l'Île de la Réunion
                  </p>
                  <div className="flex flex-col items-center mt-auto">
                    <Link
                      to="/groupement/amair"
                      className="text-slate-600 hover:text-black font-medium flex items-center group mb-4"
                    >
                      En savoir plus
                      <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </Link>
                    <Link
                      to="/adhesion/amair"
                      className="w-full text-lg font-semibold px-6 py-2 bg-[#95EF0D] text-white rounded-lg hover:bg-[#95EF0D] transition-colors"
                    >
                      Adhérer
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Carte COOPEMIEL */}
            <div className="relative group text-center">
              <div className="relative bg-white rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden border border-slate-100 h-full flex flex-col">
                <div className="p-12 flex flex-col flex-grow">
                  <img src="/logos/logo_coopemiel.png" alt="" className="mx-auto pb-8 h-46 object-contain" />
                  <p className="text-lg font-medium text-black mb-3 flex-grow min-h-[3.5rem]">
                    Coopémiel de Bourbon
                  </p>
                  <div className="flex flex-col items-center mt-auto">
                    <Link
                      to="/groupement/coopemiel"
                      className="text-slate-600 hover:text-black font-medium flex items-center group mb-4"
                    >
                      En savoir plus
                      <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </Link>
                    <Link
                      to="/adhesion/coopemiel"
                      className="w-full text-lg font-semibold px-6 py-2 bg-black text-white rounded-lg hover:bg-black transition-colors"
                    >
                      Adhérer
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Autres Services */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-semibold text-slate-900 sm:text-4xl">
              Nos services
            </h2>
            <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-500">
              Découvrez tous les services à votre disposition
            </p>
          </div>

          <div className="mt-12 flex gap-8">
            {/* Actualités */}
            <Link
              to="/actualites"
              className="w-[33%] hover:w-[80%] group bg-white rounded-xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="relative bg-image-overlay" style={{backgroundImage: "url('/accueil/actualites.jpg')", height: "250px", width: "100%", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center"}}>
                <div className="relative z-10 p-8 flex h-full align-center items-end justify-between">
                  <h3 className="text-xl font-bold text-white">
                    Les actualités
                  </h3>
                  <ArrowRightIcon className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform text-white" />
                </div>
              </div>
            </Link>

            {/* Formations */}
            <Link
              to="/formations"
              className="w-[33%] hover:w-[80%] group bg-white rounded-xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="relative bg-image-overlay" style={{backgroundImage: "url('/accueil/formations.jpg')", height: "250px", width: "100%", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center"}}>
                <div className="relative z-10 p-8 flex h-full align-center items-end justify-between">
                  <h3 className="text-xl font-bold text-white">
                    Nos formations
                  </h3>
                  <ArrowRightIcon className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform text-white" />
                </div>
              </div>
            </Link>

            {/* Miellerie */}
            <Link
              to="/miellerie"
              className="w-[33%] hover:w-[80%] group bg-white rounded-xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="relative bg-image-overlay" style={{backgroundImage: "url('/accueil/miellerie.jpg')", height: "250px", width: "100%", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center"}}>
                <div className="relative z-10 p-8 flex h-full align-center items-end justify-between">
                  <h3 className="text-xl font-bold text-white">
                    La miellerie collective
                  </h3>
                  <ArrowRightIcon className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform text-white" />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
